import { ChangeDetectorRef, Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatBottomSheet, MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SwiperOptions } from 'swiper';
import { CoponAddedDialogComponent } from '../copon-added-dialog/copon-added-dialog.component';
import { CouponsService } from 'src/app/shared/services/coupons.service';
import { CommonFunctions } from 'src/app/shared/common-functions';
import { EncryptDecryptService } from 'src/app/core/services/encrypt-decrypt.service';
import { StorageService } from 'src/app/shared/services/storage.service';
@Component({
  selector: 'app-apply-reward-dialog',
  templateUrl: './apply-reward-dialog.component.html',
  styleUrls: ['./apply-reward-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ApplyRewardDialogComponent implements OnInit {
  public beveragesCount: number = 10;
  public applyCouponVal = '';
  public rewardText: string = 'Details';
  public clikedIndex: number;
  public wordLimit: number;
  public showRadioBtn: boolean = false;
  public isCoponApplied: boolean = false;
  public btnVal = 'Use Offer';
  public allOffers: any = [];
  public allOfferCouponCodes: any = [];
  public applicableOffersArray: any = [];
  public applicableOffersArrayNew: any = [];
  public nonApplicableOffersArray: any = [];
  public showEligibleProducts: boolean = false;
  public itemIndex: number;
  public isPhone: boolean;
  public noAOffers: boolean;
  public noNAOffers: boolean;
  constructor(
    private ref: ChangeDetectorRef,
    private commonFunction: CommonFunctions,
    private couponService: CouponsService,
    private encryptDecryptService: EncryptDecryptService,
    private bottomSheetRef: MatBottomSheetRef<ApplyRewardDialogComponent>,
    private storageService: StorageService,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    public dialog: MatDialog) {
    this.isPhone = this.commonFunction.identifyDeviceType();
  }
  ngOnInit(): void {
    this.applicableOffersArrayNew = this.data['applicableOffersArrayNew'];
    this.nonApplicableOffersArray = this.data['nonApplicableOffersArray'];
    this.noAOffers = (this.applicableOffersArrayNew != undefined && this.applicableOffersArrayNew.length > 0) ? false : true;
    this.noNAOffers = (this.nonApplicableOffersArray != undefined && this.nonApplicableOffersArray.length > 0) ? false : true;
    this.showSelectedOffers(this.data);
    this.rewardText == 'Details' ? this.wordLimit = 70 : this.wordLimit = 150;
  }
  config: SwiperOptions = {
    observer: true,
    observeParents: true,
    pagination: { el: '.swiper-pagination', clickable: true },
    autoHeight: true,
    allowTouchMove: true,
    breakpoints: {
      320: {
        slidesPerView: 1.1,
        spaceBetween: 10
      },
      480: {
        spaceBetween: 20,
        slidesPerView: 1.2
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 50,
      }
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    loop: false,
  };
  onSwiper([swiper]) {
  }
  onSlideChange() {
  }
  setControlledSwiper(event) { }
  config1: SwiperOptions = {
    observer: true,
    observeParents: true,
    pagination: { el: '.swiper-pagination', clickable: true },
    autoHeight: true,
    allowTouchMove: true,
    breakpoints: {
      320: {
        slidesPerView: 1.1,
        spaceBetween: 10
      },
      480: {
        spaceBetween: 20,
        slidesPerView: 1.2
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 50,
      }
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    loop: false,
  };
  onSwiper1([swiper]) {
  }
  onSlideChange1() {
  }
  setControlledSwiper1(event) { }
  detailCoupon(data) {
    data['showDetails'] = !data['showDetails'];
  }
  useReward(data, index) {
    if (data.conditionLevel === 'item') {
      this.showEligibleProducts = true;
      this.itemIndex = index;
    } else {
      this.showEligibleProducts = false;
      this.applyInvoiceCoupon(data);
    }
  }
  applyInvoiceCoupon(data) {
    if (data.couponNo) {
      let requestPayload = {
        "basketId": this.storageService.getBasketId(),
        "couponCode": this.encryptDecryptService.encryptData(data.couponNo),
        "skuId": ''
      }
      this.commonFunction.showLoader();
      this.couponService.applyCoupon(requestPayload).subscribe((result) => {
        let obj = result['response'];
        this.couponStatus = result['response']
        this.commonFunction.hideLoader()
        this.coponAddedSuccess(data, obj);
      }, (error) => {
        this.commonFunction.hideLoader()
        this.commonFunction.displaySnackBarMessage(error.error.response[0], 'failure')
      })
    }
  }
  closeSheet() {
    this.bottomSheetRef.dismiss(true);
  }
  coponAddedSuccess(data, obj) {
    const dialogRef = this.dialog.open(CoponAddedDialogComponent, {
      data: obj,
      width: '400px',
      panelClass: "dialog-no-padding"
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'Coupon Deleted successfully') {
        data['isApplied'] = false;
        this.showEligibleProducts = false;
        this.ref.detectChanges();
      } else {
        data['isApplied'] = true;
        this.ref.detectChanges();
      }
    })
  }
  showSelectedOffers(data) {
    if (data['couponcodes'].length != 0) {
      this.applicableOffersArrayNew.forEach(res => {
        if (data['couponcodes'].includes(res['couponNo'])) {
          res['isApplied'] = true;
        }
      })
    }
  }
  couponStatus
  selectedOffer(data, skuId) {
    if (data.couponNo != '') {
      let requestPayload = {
        "basketId": this.storageService.getBasketId(),
        "couponCode": this.encryptDecryptService.encryptData(data.couponNo),
        "skuId": skuId
      }
      this.commonFunction.showLoader();
      this.couponService.applyCoupon(requestPayload).subscribe((result) => {
        this.couponStatus = result['response']
        let obj = result['response']
        this.commonFunction.hideLoader()
        this.coponAddedSuccess(data, obj)
      }, (error) => {
        this.commonFunction.hideLoader()
        this.commonFunction.displaySnackBarMessage(error.error.response[0], 'failure')
      })
    }
  }
  removeCoupon(data) {
    this.commonFunction.showLoader();
    let requestPayload = {
      "basketId": this.storageService.getBasketId(),
      "couponCode": this.encryptDecryptService.encryptData(data['couponNo']),
      "lineItemId": "",
      "uniqueIndex": ""
    }
    this.couponService.deleteCoupon(requestPayload).subscribe(res => {
      if (res['response'] === 'Coupon Deleted successfully') {
        let obj = res['response'];
        this.commonFunction.hideLoader();
        this.coponAddedSuccess(data, obj);
      }
    }, (error) => {
      this.commonFunction.hideLoader()
      this.commonFunction.displaySnackBarMessage(error.error.response[0], 'failure')
    })
  }
  applyCoupon() {
    if (this.applyCouponVal) {
      let filter = this.applicableOffersArrayNew.find(data => data['couponNo'] === this.applyCouponVal)
      if (filter && filter['conditionLevel'] === 'invoice') {
        this.applyCouponVal = '';
        let requestPayload = {
          "basketId": this.storageService.getBasketId(),
          "couponCode": this.encryptDecryptService.encryptData(filter['couponNo']),
          "skuId": ''
        }
        this.commonFunction.showLoader();
        this.couponService.applyCoupon(requestPayload).subscribe((result) => {
          let obj = result['response'];
          this.couponStatus = result['response']
          this.commonFunction.hideLoader()
          this.coponAddedSuccess(filter, obj);
        }, (error) => {
          this.commonFunction.hideLoader()
          this.commonFunction.displaySnackBarMessage(error.error.response[0], 'failure')
        })
      } else {
        let data = 'Invalid coupon code,please try with diffrent code.'
        this.commonFunction.displaySnackBarMessage(data, 'failure')
      }
    }
    else {
      let data = 'Please enter coupon code.'
      this.commonFunction.displaySnackBarMessage(data, 'failure')
    }
  }
}
